module.exports = __webpack_public_path__ + "static/media/open-closed-button-pressed.d401f39f.png";